import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]

  select(event) {
    this.itemTargets.forEach(el => el.classList.remove("conv-messenger__item--active"))
    event.currentTarget.classList.add("conv-messenger__item--active")

    const root = this.element.closest(".conv-messenger")
    if (root) root.classList.add("conv-messenger--thread-open")
  }
}
